import { getMessage } from '@tcc/i18n';
import { ACTIVITY_COLORS } from '../constants/colors';

/**
 * Convert color from hex string to rgb object
 * @param {string} hex - The hex representation of the color, e.g. #6488F2
 * @return {object} The rgb representation of the color in an object.
 */
export function hexToRGB(hex) {
  const hexString = hex.substr(1);
  const r = parseInt(hexString.substr(0, 2), 16);
  const g = parseInt(hexString.substr(2, 2), 16);
  const b = parseInt(hexString.substr(4, 2), 16);

  return { r, g, b };
}

/**
 * Return an array with with the message and color
 * @return {Array}
 */
export const getActivityColors = () => [
  { value: getMessage('scouting.form.blueColor'), id: ACTIVITY_COLORS.blue },
  { value: getMessage('scouting.form.greenColor'), id: ACTIVITY_COLORS.green },
  {
    value: getMessage('scouting.form.purpleColor'),
    id: ACTIVITY_COLORS.purple,
  },
  { value: getMessage('scouting.form.redColor'), id: ACTIVITY_COLORS.red },
  {
    value: getMessage('scouting.form.yellowColor'),
    id: ACTIVITY_COLORS.yellow,
  },
  {
    value: getMessage('scouting.form.orangeColor'),
    id: ACTIVITY_COLORS.orange,
  },
];
